




















































































































































































































































































































import { GREEN, RED } from "@/resources/constants/busyReasons";
import { Component, Watch } from "vue-property-decorator";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import {
  CHANGE_PERMISSIONS,
  FILTER_PERMISSIONS,
} from "@/resources/constants/roles";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { SPACE_TYPE } from "@/resources/constants/space";
import UserSpacePermissionsComponent from "@/app/components/modals/userPermissions/userSpacePermissions.component.vue";
import moment from "moment";
import UserValidator from "@/resources/mixins/userValidator";
@Component({
  name: "manage-users-component",
  components: { UserSpacePermissionsComponent },
})
export default class ManageUsersComponent extends mixins(
  NotificationEvent,
  UserValidator
) {
  isEvent = false;
  currentPage = 1;
  itemsPerPage = 30;
  lastPage = 1;
  loader = false;
  search = "";
  filters = FILTER_PERMISSIONS;
  totalUsers = 0;
  optionSelected = 0;
  permissions = CHANGE_PERMISSIONS;
  collectionPermissionValue = true;
  collectionPermissionSelected = "isWebinarHost";
  auxUsers = [];
  timeout = undefined;
  showPermission = false;
  userShow = null;
  moment = moment;
  superAdmin = false;
  allCheck = false;
  selected = [];
  loadingCollection = false;
  constructor() {
    super();
  }
  @Watch("currentPage")
  updatePage(): void {
    this.selected = [];
    this.getUsers();
  }
  @Watch("optionSelected")
  updateOptionSelected(): void {
    this.selected = [];
    if (this.currentPage == 1) this.getUsers();
    else this.currentPage = 1;
  }
  @Watch("search")
  updateoSearch(): void {
    this.selected = [];
    if (this.timeout != undefined) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (this.currentPage == 1) this.getUsers();
      else this.currentPage = 1;
      this.timeout = undefined;
    }, 1000);
  }
  @Watch("selected")
  selectUsers() {
    // do nothing
  }
  mounted(): void {
    if (this.$route.name === "multi_spaces" || this.$route.name === "spaces")
      this.superAdmin = true;
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const selectedSpaceCustomize = space;
    if (
      selectedSpaceCustomize &&
      selectedSpaceCustomize.type &&
      selectedSpaceCustomize.type == SPACE_TYPE.EVENT_TYPE
    )
      this.isEvent = true;
    this.getUsers();
    document.getElementById("vs-input--input-search").focus();
  }
  getUsers(): void {
    this.loader = true;
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getUsersAction", {
      spaceId: this.$route.params.id ?? space.id,
      page: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      search:
        this.search != ""
          ? "&search=" +
            this.search
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
          : "",
      permissions: this.getPermisions(),
      callback: (response) => {
        this.auxUsers = response.data;
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        this.itemsPerPage = parseInt(
          response.headers["pagination-items-per-page"]
        );
        this.totalUsers = parseInt(response.headers["pagination-total-items"]);
        this.loader = false;
      },
      callbackError: (error) => {
        this.loader = false;
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
      },
    });
  }
  get users(): Array<SpaceUserInterface> {
    return this.auxUsers;
  }
  set users(users: Array<SpaceUserInterface>) {
    this.auxUsers = users;
  }
  get user(): SpaceUserInterface {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  getPermisions(): string {
    switch (this.optionSelected) {
      case 1:
        return "&isAdmin=true";
      case 2:
        return "&canInvite=true";
      case 3:
        return "&isWebinarHost=true";
      case 4:
        return "&canSendConsoleMessage=true";
      case 5:
        return "&isTrial=true";
      case 6:
        return "&enabled=false";
      case 7:
        return "&isAdmin=false&canInvite=false&isWebinarHost=false&canSendConsoleMessage=false&isTrial=false&canPinChatMessage=false&canBan=false";
      case 8:
        return "&connectionStatus=ONLINE";
      case 9:
        return "&canPinChatMessage=true";
      case 10:
        return "&canBan=true";
      default:
        return "";
    }
  }
  loadEmail(user: UserInterface): string {
    if (this.isEvent && user.isGuest) {
      return user.socialEmail ? user.socialEmail : "";
    }
    return user.email;
  }
  openPermissionModal(user) {
    this.showPermission = true;
    this.userShow = user;
  }
  closePermissionModal(e) {
    this.showPermission = e;
    this.userShow = null;
  }
  setAvatarColor(color: string): string {
    switch (color) {
      case GREEN.type:
        return GREEN.color;
      case RED.type:
        return RED.color;
      default:
        return RED.color;
    }
  }
  async onChangeCollectionPermissions() {
    this.loadingCollection = true;
    const usersMapped = await this.selected.map((user) => {
      return {
        id: user.id,
        [this.collectionPermissionSelected]: this.collectionPermissionValue,
      };
    });
    this.$store.dispatch("SpaceUserStore/changeCollectionPermissionsAction", {
      data: usersMapped,
      callback: async (response) => {
        await this.selected.map(async (user) => {
          const index = this.auxUsers.findIndex((a) => a.id === user.id);
          user[this.collectionPermissionSelected] =
            this.collectionPermissionValue;
          if (index >= 0) {
            this.auxUsers.splice(index, 1, user);
            await this.$store.dispatch(
              "SpaceStore/addUsersInSpaceAction",
              this.auxUsers
            );
          }
        });
        this.loadingCollection = false;
        this.selected = [];
        /* const index = this.auxUsers.findIndex((a) => a.id === user.id);
        if (index >= 0) {
          await this.$store.dispatch(
            "SpaceStore/addUsersInSpaceAction",
            this.auxUsers
          );
          this.auxUsers.splice(index, 1, user);
        } */
      },
    });
  }
  disableOrEnableUser(spaceUser): void {
    this.$store.dispatch("SpaceUserStore/enableUserAction", {
      spaceId: spaceUser.id,
      data: { enabled: !spaceUser.enabled },
      callback: async (user) => {
        const index = this.auxUsers.findIndex((a) => a.id === user.id);
        if (index >= 0) {
          spaceUser.enabled = user.enabled;
          this.auxUsers.splice(index, 1, user);
        }
      },
    });
  }
}
